import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {getAuthModel} from '../../auth'
import {iCopyTemplate, Template} from './templateModels'

const API_URL: string | undefined = process.env.REACT_APP_API_URL

export const templatesApi = createApi({
  reducerPath: 'templatesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_URL}`,
    prepareHeaders: (headers, {getState}) => {
      const auth = getAuthModel()
      if (auth?.access_token) {
                headers.set('authorization', `Bearer ${auth.access_token}`)
            }
      return headers
    },
  }),
  tagTypes: ['Template', 'Position', 'Section'],
  refetchOnMountOrArgChange: 30,

  endpoints: (builder) => ({

    addTemplate: builder.mutation<Object, Template>({
      query: (data) => ({
        url: 'template',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Template', 'Position', 'Section'],
    }),

    updateTemplate: builder.mutation<Object, Template>({
        query: ({template_id, ...rest}) => ({
            url: `template/${template_id}`,
            method: "PUT",
            body: rest
        }),
        invalidatesTags: ['Template', 'Position', 'Section']            
    }),

    duplicateTemplate: builder.mutation<Object, iCopyTemplate>({
        query: ({template_id, ...rest}) => ({
            url: `template/${template_id}/copy`,                
            method: "POST",     
            body: rest
        }),
        invalidatesTags: ['Template', 'Position', 'Section']           
    }),

    deleteTemplate: builder.mutation<Object, string>({
        query: (id) => ({
            url: `template/${id}`,
            method: "DELETE"
        }),
        invalidatesTags: ['Template', 'Position', 'Section'] 
    }),

    getAllTemplates: builder.query<Template[], number>({
      query: () => 'template',
      providesTags: ['Template', 'Position', 'Section'],
      // keepUnusedDataFor: 5,   // configuration for an individual endpoint, overriding the api setting
    }),
    getTemplate: builder.query<Template, string>({
      query: (id) => `template/${id}`,
      providesTags: ['Template', 'Position', 'Section'],
    }),
    getAllPlaylistTemplates: builder.query<Template, void>({
      query: () => `template/playlist`,
      providesTags: ['Template', 'Position', 'Section'],
    }),
  }),
})

export const {
    useGetAllTemplatesQuery, 
    useGetTemplateQuery, 
    useGetAllPlaylistTemplatesQuery,
    useAddTemplateMutation,
    useUpdateTemplateMutation,
    useDuplicateTemplateMutation,
    useDeleteTemplateMutation
} = templatesApi
